import 'reflect-metadata';
// -----------------------------------------------------------------------------
const kConditionTypeMetadataKey = Symbol('ConditionType');

// -----------------------------------------------------------------------------
export enum ConditionType {
  Global,
  AllApps,
  AppSpecific,
  GameEvent,
}

// -----------------------------------------------------------------------------
// @conditionType
export const conditionType = (type: ConditionType) => {
  return (target: any) => {
    Reflect.defineMetadata(kConditionTypeMetadataKey, type, target.prototype);
    return target;
  };
};

// -----------------------------------------------------------------------------
export const getConditionType = (target: any): ConditionType => {
  return Reflect.getMetadata(kConditionTypeMetadataKey, target);
};
